import classNames from "classnames";
import moment from "moment";
import React from "react";
import { TBallastRecord } from "../../../../../redux/app/ballast/@types";
import { TBallast_Ballast } from "../../../../../redux/app/ballast/groups/ballast";
import CommaSeparator from "../../../../_common/CommaSeparator";
import BallastTableRows from "../_elements/BallastTableRows";
import { TBallast_Exchange } from "redux/app/ballast/groups/exchange";

import versions from "../../../../../redux/app/ballast/versions";

type OwnProps = {
	ballastRecord: TBallastRecord;
	isStrikedOff?: boolean;
};
type ExchangeOperationPreviewProps = OwnProps;
function ExchangeOperationPreview(props: ExchangeOperationPreviewProps) {
	const record = props.ballastRecord as TBallast_Exchange;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		if (record.version === versions[0].value) {
			return (
				<BallastTableRows
					record={record}
					tableRows={[
						[operationDate, "C", "1.1", renderItem1P1()],
						[null, null, "1.2", renderItem1P2()],
						[null, null, "1.3", renderItem1P3()],
						[null, null, "1.4", renderItem1P4()],
						[null, null, "1.5", renderItem1P5()],
						[null, null, "1.6", renderItem1P6()],
						[null, null, "1.7", renderItem1P7()],
						[null, null, "NOTE", record.remarks],
					]}
				/>
			);
		} else {
			return (
				<BallastTableRows
					record={record}
					tableRows={[
						[operationDate, null, "3.2.1", renderItem3P2P1()],
						[null, null, "3.2.2", renderItem3P2P2()],
						[null, null, "3.2.3", renderItem3P2P3()],
						[null, null, "NOTE", record.remarks],
					]}
				/>
			);
		}
	}

	// MEPC.369(80)
	function renderItem1P1() {
		const smtStartDate = record.tanks[0].startDate;
		const smtStartTime = record.tanks[0].startTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtStartDate}T${smtStartTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at{" "}
							{record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at Lat{" "}
							{record.placeOfBallast.startPosition.latitude} / Long{" "}
							{record.placeOfBallast.startPosition.longitude}
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Start - {record.tanks[0].startTime} hrs (UTC) on{" "}
							{moment(record.tanks[0].startDate, "YYYY-MM-DD").format(
								"DD-MMM-YYYY"
							)}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Start - {record.tanks[0].startTime} hrs (UTC) on{" "}
							{moment(record.tanks[0].startDate, "YYYY-MM-DD").format(
								"DD-MMM-YYYY"
							)}{" "}
							at Lat {record.placeOfBallast.startPosition.latitude} / Long{" "}
							{record.placeOfBallast.startPosition.longitude}
						</>
					) : null}
				</>
			);
		}
	}
	function renderItem1P2() {
		const smtEndDate = record.tanks[record.tanks.length - 1].endDate;
		const smtEndTime = record.tanks[record.tanks.length - 1].endTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtEndDate}T${smtEndTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at{" "}
							{record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at Lat{" "}
							{record.placeOfBallast.endPosition.latitude}/ Long{" "}
							{record.placeOfBallast.endPosition.longitude}
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Completion - {record.tanks[record.tanks.length - 1].endTime} hrs
							(UTC) on{" "}
							{moment(
								record.tanks[record.tanks.length - 1].endDate,
								"YYYY-MM-DD"
							).format("DD-MMM-YYYY")}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Completion - {record.tanks[record.tanks.length - 1].endTime} hrs
							(UTC) on{" "}
							{moment(
								record.tanks[record.tanks.length - 1].endDate,
								"YYYY-MM-DD"
							).format("DD-MMM-YYYY")}{" "}
							at Lat {record.placeOfBallast.endPosition.latitude}/ Long{" "}
							{record.placeOfBallast.endPosition.longitude}
						</>
					) : null}
				</>
			);
		}
	}
	function renderItem1P3() {
		return (
			<h4 className="font-medium uppercase">
				Minimum distance {record.minimumDistance} nm and minimum depth{" "}
				{record.depth} meters
			</h4>
		);
	}
	function renderItem1P4() {
		return <h4 className="font-medium uppercase">{record.approvedBWMP}</h4>;
	}
	function renderItem1P5() {
		let tankNames = "";
		record.tanks.forEach((tank, index) => {
			tankNames += tank.selectedTank.tankCode;
			if (index !== record.tanks.length - 1) {
				tankNames += ",";
			}
		});
		return tankNames;
	}
	function renderItem1P6() {
		// let accumulatedValue = 0;
		// accumulatedValue = record.tanks.reduce(
		//     (acc, curr) => acc + curr.newRetainedQuantity,
		//     0
		// );
		return (
			<h4 className="font-medium uppercase">
				Exchanged {record.totalOperatedWaterVolume} M³. Final quantity retained:{" "}
				{record.ballastROB.toFixed(2)} M³
			</h4>
		);
	}
	function renderItem1P7() {
		return <h4 className="font-medium uppercase">{record.treatmentMethod}</h4>;
	}

	// MEPC 70
	function renderItem3P2P1() {
		return (
			<h4 className="font-medium uppercase">
				{validateAndPreviewPlaceAndPosition()}
			</h4>
		);
	}
	function renderItem3P2P2() {
		return (
			<h4 className="font-medium uppercase">
				{record.totalOperatedWaterVolume} M³,{" "}
				{record.ballastROB
					? `Total Retained Quantity Onboard: ${record.ballastROB.toFixed(
							2
					  )} M³`
					: ""}
			</h4>
		);
	}
	function renderItem3P2P3() {
		if (!record.isBallastWaterTreatmentPlanUsed) return null;
		return (
			<h4 className="font-medium uppercase">
				{record.isBallastWaterTreatmentPlanUsed ? "YES" : "NO"}
			</h4>
		);
	}
	const validateAndPreviewPlaceAndPosition = () => {
		return (
			<>
				{record.placeOfBallast.place === "IN_PORT" ? (
					<>
						{moment(record.tanks[0].startDate, "YYYY-MM-DD").format(
							"DD-MMM-YYYY"
						)}{" "}
						{record.tanks[0].startTime} to{" "}
						{moment(
							record.tanks[record.tanks.length - 1].endDate,
							"YYYY-MM-DD"
						).format("DD-MMM-YYYY")}{" "}
						{record.tanks[record.tanks.length - 1].endTime},{" "}
						{record.placeOfBallast.portName}
					</>
				) : null}
				{record.placeOfBallast.place === "AT_SEA" ? (
					<>
						{moment(record.tanks[0].startDate, "YYYY-MM-DD").format(
							"DD-MMM-YYYY"
						)}{" "}
						{record.tanks[0].startTime}{" "}
						{record.placeOfBallast.startPosition.latitude},{" "}
						{record.placeOfBallast.startPosition.longitude}, to{" "}
						{moment(
							record.tanks[record.tanks.length - 1].endDate,
							"YYYY-MM-DD"
						).format("DD-MMM-YYYY")}{" "}
						{record.tanks[record.tanks.length - 1].endTime},{" "}
						{record.placeOfBallast.endPosition.latitude},{" "}
						{record.placeOfBallast.endPosition.longitude}, DEPTH: {record.depth}
						M
					</>
				) : null}
			</>
		);
	};

	return renderMain();
}

export default ExchangeOperationPreview;
